import { isArray, isNil } from 'lodash'
import { SchoolDistrict } from '../../models/school-district.model'

export const getSchoolDistrictCode = (schoolDistricts?: SchoolDistrict[], selectedValue?: string): number | null => {
  if (!isArray(schoolDistricts) || isNil(selectedValue)) return null
  const schoolDistrict = schoolDistricts.find((sd: SchoolDistrict) => sd.school_district_name === selectedValue)
  return schoolDistrict?.school_district_code || null
}
